import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

import logo from '../images/logo.svg'

export default class Header extends Component {
  render() {
    const { name } = this.props
    return (
      <Nav>
        <Title href="/">
          <Logo src={logo} alt="logo" />
          <h3 data-testid="projectName">{name || '项目名称'}</h3>
        </Title>
        <Menu data-testid="menu">
          <li>
            <a href="/">首页</a>
          </li>
          <li>
            <Link to="/list">列表</Link>
          </li>
        </Menu>
      </Nav>
    )
  }
}

const Nav = styled.nav`
  padding: 0 10%;
  color: white;
  background: #0b0812;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 100;
`

const Title = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;

  h3 {
    color: white;
    text-decoration: none;
  }
`

const Menu = styled.ul`
  display: flex;
  align-items: center;
  justify-content: space-between;
  li {
    list-style: none;
    a {
      color: white;
      margin-right: 12px;
      text-decoration: none;
    }
  }
`

const Logo = styled.img`
  animation: logo-spin infinite 20s linear;
  height: 60px;
  pointer-events: none;

  @keyframes logo-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`
